import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import Swal from 'sweetalert2';
import { SupplyService } from '../supply.service';

@Component({
  selector: 'app-supply-catalog',
  templateUrl: './supply-catalog.component.html',
  styleUrls: ['./supply-catalog.component.scss']
})
export class SupplyCatalogComponent implements OnInit {
  loading = false;
  productTypes: any[] = [];
  dispatchRows: any[] = [];

  constructor(private supplyService: SupplyService) {}

  ngOnInit(): void {
    this.loadCatalog();
  }

  loadCatalog(): void {
    this.loading = true;
    forkJoin({
      productTypes: this.supplyService.getProducts(),
      dispatchRows: this.supplyService.getDispatches()
    }).subscribe({
      next: ({ productTypes, dispatchRows }) => {
        this.productTypes = productTypes || [];
        this.dispatchRows = dispatchRows || [];
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        Swal.fire('Error', err?.error?.message || 'Failed to load supply catalog intelligence.', 'error');
      }
    });
  }

  get catalogHealth(): Array<{ name: string; items: number; dispatches: number; status: string }> {
    return this.productTypes.map((type) => {
      const itemIds = new Set((type?.items || []).map((item: any) => item.id));
      const dispatches = this.dispatchRows.filter((row) => itemIds.has(row?.productItemId)).length;
      const items = type?.items?.length || 0;
      const status = items === 0 ? 'Empty' : dispatches === 0 ? 'Dormant' : dispatches < 3 ? 'Emerging' : 'Active';
      return {
        name: type?.name || 'Unnamed Type',
        items,
        dispatches,
        status
      };
    }).sort((a, b) => b.dispatches - a.dispatches);
  }

  get dormantTypes(): any[] {
    return this.catalogHealth.filter((row) => row.status === 'Dormant' || row.status === 'Empty').slice(0, 6);
  }

  get activeTypes(): any[] {
    return this.catalogHealth.filter((row) => row.status === 'Active').slice(0, 6);
  }

  get itemUtilization(): Array<{ label: string; value: number }> {
    const map = new Map<string, number>();
    this.dispatchRows.forEach((row) => {
      const key = String(row?.productItemName || 'Unknown Item').trim() || 'Unknown Item';
      map.set(key, (map.get(key) || 0) + 1);
    });

    return Array.from(map.entries())
      .map(([label, value]) => ({ label, value }))
      .sort((a, b) => b.value - a.value)
      .slice(0, 8);
  }
}
